import { render, staticRenderFns } from "./ReviewSummaryPage.vue?vue&type=template&id=2b89a87b&"
import script from "./ReviewSummaryPage.vue?vue&type=script&lang=js&"
export * from "./ReviewSummaryPage.vue?vue&type=script&lang=js&"
import style0 from "./ReviewSummaryPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports